var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNfsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#163f68",
    fillRule: "evenodd",
    d: "M26.442 46.73H24.2l-3.611-6.279h-.051q.108 1.664.108 2.373v3.906h-1.568v-8.3H21.3l3.6 6.217h.04q-.085-1.618-.085-2.288V38.43h1.584zm3.821 0h-1.732v-8.3h4.758v1.442h-3.026v2.14h2.816v1.436h-2.816zm9.55-2.305A2.146 2.146 0 0 1 39 46.2a3.514 3.514 0 0 1-2.251.647 5.287 5.287 0 0 1-2.35-.5v-1.638a9.686 9.686 0 0 0 1.422.528 4.208 4.208 0 0 0 1.065.153 1.514 1.514 0 0 0 .889-.221.757.757 0 0 0 .309-.659.727.727 0 0 0-.136-.434 1.525 1.525 0 0 0-.4-.366 10.294 10.294 0 0 0-1.076-.562 5.1 5.1 0 0 1-1.141-.687 2.579 2.579 0 0 1-.607-.766 2.187 2.187 0 0 1-.227-1.022 2.145 2.145 0 0 1 .747-1.732 3.1 3.1 0 0 1 2.064-.63 4.873 4.873 0 0 1 1.235.153 8.489 8.489 0 0 1 1.229.431l-.572 1.369a8.307 8.307 0 0 0-1.1-.38 3.536 3.536 0 0 0-.854-.108 1.131 1.131 0 0 0-.766.233.768.768 0 0 0-.267.607.752.752 0 0 0 .108.406 1.186 1.186 0 0 0 .343.335 10.622 10.622 0 0 0 1.116.582 4.439 4.439 0 0 1 1.6 1.116 2.177 2.177 0 0 1 .432 1.37z",
    transform: "translate(2.922 2.554)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5498e0",
    fillRule: "evenodd",
    d: "M47 19v7.467H15V19zm-2 2.8h-2v1.867h2zm-4 0h-2v1.867h2zm-4 0h-2v1.867h2z",
    transform: "translate(1 1.267)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279c5",
    fillRule: "evenodd",
    d: "M47 27v7.467H15V27zm-2 2.8h-2v1.867h2zm-4 0h-2v1.867h2zm-4 0h-2v1.867h2z",
    transform: "translate(1 1.8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfsDefault);
export default __webpack_public_path__ + "static/media/nfs-default.ca1095a1c7a917c02491624606ab60d5.svg";
export { ForwardRef as ReactComponent };